import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-chalk px-5 py-20 sm:py-28" data-id="element-78" data-mp="1l9o779vjm1m9">
      <div className="mx-auto max-w-2xl" data-id="element-79" data-mp="1ge0fampoeud2">
        <h2 className="text-center font-display text-[2rem] font-extrabold uppercase leading-tight text-ink sm:text-[2.8rem]" data-id="element-80" data-mp="1gauu3ik64cmm">
          Frequently Asked Questions
        </h2>

        <div className="mt-10 space-y-3" data-id="element-81" data-mp="2924rzs6o07p9">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-xl border border-ink/5 bg-white" data-id="element-82" data-mp="1z3yox794gvit" data-mpi={index}>
                <h3 data-id="element-83" data-mp="sl0favgagdzq">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40" data-id="element-84" data-mp="no0asoz37jaq">
                    <span className="text-sm font-bold text-ink" data-id="element-85" data-mp="fj8ldwsc6rga">{faq.q}</span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-brand transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-86" data-mp="khtgjhsqekxv" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-87" data-mp="3t07t250oji4r">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-88" data-mp="1teqoxu5hcyn">
                      <p className="px-6 pb-5 text-sm leading-relaxed text-ink/60" data-id="element-89" data-mp="1pq4i2lbuqcwx">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}